<template>
  <div class="hm-transfer p10">
    <div class=" flex item-center">
      <el-input
        clearable
        style="width:200px"
        v-model.trim="searchCondition.queryKey"
        placeholder="请输入账户/用户/手机号/工号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-cascader
        clearable
        style="marginRight:10px"
        ref="cascader"
        v-model="searchCondition.selectedStore"
        :props="props"
        :show-all-levels="false"
        size="small"
        placeholder="请选择机构"
      ></el-cascader>
      <!-- <el-select
        clearable
        style="marginRight:10px"
        size="small"
        v-model="searchCondition.workingState"
        placeholder="请选择在职状态"
      >
        <el-option label="在职" value="yes"> </el-option>
        <el-option label="离职" value="no"> </el-option>
      </el-select> -->
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="flex item-center">
      <!-- 左边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1  text-center">
            <el-checkbox
              :indeterminate="leftIsIndeterminate"
              :disabled="leftData.length <= 0"
              v-model="leftCheckAll"
              @change="handleLeftCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="leftName">可选范围</span>
          </div>
          <!-- <div class="transfer-title flex-2 text-center">可选范围</div> -->
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 num">导购工号</div>
          <div class="flex-1 name">导购名称</div>
          <div class="flex-1 name text-center">手机号</div>
        </div>

        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="leftChecked"
              @change="handleLeftCheckedChange"
            >
              <div
                v-for="(v, i) in leftData"
                :key="i"
                class="check-wrapper flex item-center"
                :title="v.realname"
              >
                <div class="flex-4">
                  <el-checkbox :label="v" class="flex">
                    <el-tooltip :content="v.workNum" placement="top">
                      <span class="flex-1 attrid">{{ v.workNum }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.realname" placement="top">
                      <span class="flex-1 goods-name">{{ v.realname }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.phone" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.phone
                      }}</span>
                    </el-tooltip>
                    <!-- <span
                      class="success flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'running'"
                      >进行中</span
                    >
                    <span
                      class="gray flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'notStarted'"
                      >未开始</span
                    >
                    <span
                      class="danger flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'end'"
                      >已结束</span
                    >

                    <el-tooltip :content="v.typeName" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.typeName
                      }}</span>
                    </el-tooltip>

                    <span class="flex-2 goods-name text-center"
                      >{{ v.startDate }}至{{ v.endDate }}</span
                    >
                    <span class="flex-1 text-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >详情</el-button
                      >
                    </span> -->
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total,  prev, pager, next, jumper"
              :current-page="currentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="flex flex-column control text-center">
        <div class="mb20">操作</div>
        <!-- <el-switch
          v-model="isMustDelivery"
          v-if="showMustDelivery"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="yes"
          active-text="必选"
          inactive-text="可选"
          inactive-value="no"
        >
        </el-switch> -->
        <!-- <el-switch
          size="mini"
          class="transfer-switch"
          v-if="showUseable"
          v-model="whitelistState"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch> -->
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="leftData.length <= 0 || leftChecked.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="rightData.length <= 0 || rightChecked.length <= 0"
        ></el-button>
        <!-- <el-button
          size="small"
          class="hmicon icon-zuojiantou delete-selected"
          @click="deleteChecked"
          :disabled="leftChecked.length <= 0 || rightData.length <= 0"
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button> -->
      </div>
      <!-- 右边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1 text-center">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="rightData.length <= 0"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
            <span class="rightName">已选范围</span>
          </div>
          <!-- <div class="transfer-title flex-2 text-center">已选范围</div> -->
        </div>
        <div class="table-header flex flex-between">
          <div class="flex-1 num">导购工号</div>
          <div class="flex-1 name">导购名称</div>
          <div class="flex-1 name text-center">手机号</div>
        </div>

        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="rightChecked"
              @change="handleRightCheckedChange"
            >
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper   item-center"
              >
                <!-- <div class="flex">
                  <el-checkbox :label="v" class="flex flex-3 item-center">
                    <el-tooltip :content="v.promotionName" placement="top">
                      <span class="flex-1 attrid">{{ v.promotionName }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.typeName" placement="top">
                      <span class="flex-2 goods-name text-center">{{
                        v.typeName
                      }}</span>
                    </el-tooltip>

                    <span class="flex-2 goods-name text-center"
                      >{{ v.startDate }}至{{ v.endDate }}</span
                    >
                  </el-checkbox>
                </div> -->
                <div class="flex-4">
                  <el-checkbox :label="v" class="flex">
                    <el-tooltip :content="v.workNum" placement="top">
                      <span class="flex-1 attrid">{{ v.workNum }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.realname" placement="top">
                      <span class="flex-1 goods-name">{{ v.realname }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.phone" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.phone
                      }}</span>
                    </el-tooltip>
                    <!-- <span
                      class="success flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'running'"
                      >进行中</span
                    >
                    <span
                      class="gray flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'notStarted'"
                      >未开始</span
                    >
                    <span
                      class="danger flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'end'"
                      >已结束</span
                    >
                    <el-tooltip :content="v.typeName" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.typeName
                      }}</span>
                    </el-tooltip>

                    <span class="flex-2 goods-name text-center"
                      >{{ v.startDate }}至{{ v.endDate }}</span
                    >
                    <span class="flex-1 text-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >详情</el-button
                      >
                    </span> -->
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
          <div class="hm-pagination" style="opacity:0">
            <el-pagination background></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!notValid && rightChecked.length <= 0" class="error">
      请绑定导购
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: { type: String },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    transferMode: { type: String },
    isPreview: { type: Boolean },
    notValid: { type: Boolean },
    onlySelectOne: { type: Boolean }
  },
  components: {},
  data() {
    return {
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      searchCondition: {
        selectedStore: []
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryActivityList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryActivityList();
    },
    async queryActivityList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        loginType: "store",
        workingState: "yes"
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      //   searchCondition.startDate =
      //     this.searchCondition.ruleValidDate &&
      //     this.searchCondition.ruleValidDate.length > 0
      //       ? this.searchCondition.ruleValidDate[0]
      //       : "";
      //   searchCondition.endDate =
      //     this.searchCondition.ruleValidDate &&
      //     this.searchCondition.ruleValidDate.length > 0
      //       ? this.searchCondition.ruleValidDate[1]
      //       : "";
      if (this.searchCondition.selectedStore.length) {
        searchCondition.orgCode = this.searchCondition.selectedStore[
          this.searchCondition.selectedStore.length - 1
        ];
      }

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryEmployee", params);
      const { records, total } = result;

      this.leftData = records;
      this.rightData.forEach(v => {
        this.leftData.forEach((item, index) => {
          if (v.id === item.id) {
            this.leftData.splice(index, 1);
          }
        });
      });
      //   if (this.beltType === "promotion") {
      //   } else if (this.beltType === "coupon") {
      //     this.rightData.forEach(v => {
      //       this.leftData.forEach((item, index) => {
      //         if (v.ruleId === item.ruleId) {
      //           this.leftData.splice(index, 1);
      //         }
      //       });
      //     });
      //   }

      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryActivityList();
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftData
          //     })
          //     .then(res => {
          //       if (this.leftData.length > 0) {
          //         this.rightData = this.rightData.concat(res.result);
          //         this.rightData.forEach(v => {
          //           v.activityName = v.existActivity
          //             ? v.existActivity.map(item => item.promotionName)
          //             : [];
          //           v.activityStr = v.activityName.join(",");
          //           if (this.isMustDelivery) {
          //             v.isMustDelivery = this.isMustDelivery;
          //           }
          //         });
          //         this.leftData = [];
          //         this.leftChecked = [];
          //       }
          //       this.handleRightCheckAllChange(true);
          //       this.leftCheckAll = false;
          //       this.rightCheckAll = true;
          //     });
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
    },
    toRight() {
      // 移动选中到右边
      const result = this.checkCommon(this.leftChecked, this.rightData);
      if (!result) {
        // if (this.showUseable) {
        //   this.leftData.forEach(v => {
        //     v.whitelistState = this.whitelistState;
        //   });
        // }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          //   this.rightData.forEach(v => {
          //     if (this.isMustDelivery) {
          //       v.isMustDelivery = this.isMustDelivery;
          //     }
          //   });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v.id === this.leftChecked[0].id) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v.id === item.id) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);

      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (v.id === this.rightChecked[0].id) {
              this.rightData.splice(i, 1);
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (v.id === item.id) {
                this.rightData.splice(index, 1);
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.id) === String(item.id)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
    },
    handleCheckChangeAttribute() {
      this.isCheckedAttribute =
        this.$refs.attributeTree.getCheckedNodes().length > 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.leftName,
.rightName {
  margin-left: -52px;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  //   max-width: 500px;
  width: 700px;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      margin-left: 26px;
    }
    .name {
      margin-left: -26px;
    }
  }
  .table-body {
    font-size: 12px;

    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
  .goods-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    box-sizing: border-box;
    width: 100px;
  }
}

.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
}
</style>
